import React, { FC } from 'react';

const StitcherIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="20"
    height="20"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="#000000" fillRule="nonzero">
        <path
          d="M4.16666667,6.83333333 L7.5,6.83333333 L7.5,13.5 L4.16666667,13.5 L4.16666667,6.83333333 Z M0,7.66666667 L3.33333333,7.66666667 L3.33333333,14.3333333 L0,14.3333333 L0,7.66666667 Z M8.33333333,7.66666667 L11.6666667,7.66666667 L11.6666667,14.3333333 L8.33333333,14.3333333 L8.33333333,7.66666667 Z M12.5,6 L15.8333333,6 L15.8333333,13.5 L12.5,13.5 L12.5,6 Z M16.6666667,7.66666667 L20,7.66666667 L20,12.6666667 L16.6666667,12.6666667 L16.6666667,7.66666667 Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default StitcherIcon;
